import { MutationModal } from './MutationModal'
import { CIMSModalWrapperProps } from '../../CIMSModal/types'
import { useCIMSTableContext } from '../CIMSTableContext'

function SimpleCreateModal<T extends object>({
  onClose,
  visible,
}: CIMSModalWrapperProps<null>) {
  const { actions } = useCIMSTableContext<T>()
  const { entity, modal } = actions.header.create ?? {}
  if (!modal) return null
  const title = `Create ${entity}`
  return (
    <MutationModal
      onClose={onClose}
      title={title}
      visible={visible}
      modal={
        modal.type === 'custom'
          ? { type: 'custom', props: { ...modal, type: 'create' } }
          : { type: 'simple', props: { ...modal, type: 'create' } }
      }
    />
  )
}

export default SimpleCreateModal
